module.exports = "/static/assets/d34dbc2d88a3e8dc9d81770eb9145b08.png";